import { ITheme } from "smarthub-common";
import { IProps } from "../props";
import { genericTheme } from "./generic.theme";

const personalityMapping = {
  generic: [genericTheme],
};

export const themes = ({ id }: IProps): ITheme[] => personalityMapping[id];
